import React from "react";
import { formValueSelector, reduxForm } from "redux-form";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import cx from "classnames";

import { openHeaderModal, closeHeaderModal } from "../../actions/siteadmin/modalActions";

import messages from "../../locale/messages";

import { createBookingAction } from "../../actions/booking/createBookingAction";
import withStyles from "isomorphic-style-loader/withStyles";
import { LightBulbIcon, PreferredProviderIcon, RandomProviderIcon, RightArrowIcon } from "../Common/Assets/SVGIcon/CommonSvgIcon";
import bt from '../commonStyle.css';
import s from './ProviderSelectionForm.css';

function ProviderSelectionForm({ formData }) {

    const promoId = useSelector(state => formValueSelector('PromoCodeForm')(state, 'promoId'))
    const isPromoIdRemove = useSelector(state => formValueSelector('PromoCodeForm')(state, 'isPromoIdRemove'))
    const paymentMethodId = useSelector(state => formValueSelector('PaymentMethod')(state, 'paymentMethodId'))
    const description = useSelector(state => formValueSelector('OrderDetails')(state, 'description'))
    // Parity with mobile: Book Now appointment time (W2), estimated duration (W3) and questionnaire
    // answers (W4) are collected on the OrderDetails form; carry them into the booking mutation.
    const scheduledAt = useSelector(state => formValueSelector('OrderDetails')(state, 'scheduledAt'))
    const estimatedHours = useSelector(state => formValueSelector('OrderDetails')(state, 'estimatedHours'))
    const questionnaire = useSelector(state => formValueSelector('OrderDetails')(state, 'questionnaire'))
    const isRandomProviderEnable = useSelector(state => state?.siteSettings?.data?.randomProviderSelection)
    const isPreferredProviderEnable = useSelector(state => state?.siteSettings?.data?.preferredProviderSelection)

    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const handleClick = () => {
        dispatch(closeHeaderModal('providerSelectionForm'))
        dispatch(openHeaderModal('bookingForm'))
    }

    const handleRadomProviderAction = async () => {
        const bookingData = formData?.bookingData;
        const orderItem = bookingData?.orderItemsList?.[0];

        const orderId = bookingData?.id;
        const requestCurrency = bookingData?.currency;
        const reviewDescription = description?.trim() ? description : null;

        const dropOffLocation = orderItem?.dropLocation;
        const dropOffLat = orderItem?.dropLat;
        const dropOffLng = orderItem?.dropLng;

        const validPromoId = !isPromoIdRemove
            ? promoId ?? bookingData?.promoId
            : null;

        dispatch(closeHeaderModal('providerSelectionForm'))
        dispatch(openHeaderModal('nearestProviderForm'))

        // Honor a worker shared via their /pro link (preselected as preferred), if any.
        let sharedPro = null;
        try { if (typeof window !== 'undefined') sharedPro = window.localStorage.getItem('bh_preferred_pro'); } catch (e) {}
        // No shared pro → true Choose-for-me: broadcast to ALL eligible workers (dispatchMode 'auto',
        // parity with mobile). A shared pro is a preferred booking (no broadcast).
        await dispatch(createBookingAction({ orderId, requestCurrency, reviewDescription, dropOffLocation, dropOffLat, dropOffLng, promoId: validPromoId, paymentType: Number(paymentMethodId), preferredPartnerId: sharedPro || undefined, dispatchMode: sharedPro ? undefined : 'auto', scheduledAt: scheduledAt || null, estimatedHours: estimatedHours || null, questionnaire: questionnaire || null }))
        try { if (typeof window !== 'undefined') window.localStorage.removeItem('bh_preferred_pro'); } catch (e) {}

    }

    const preferredProviderAction = () => {
        dispatch(closeHeaderModal('providerSelectionForm'))
        dispatch(openHeaderModal('preferredProviderForm'))
    }

    return (
        <>
            <div className={s.providerSectionCardWrapper}>
                {isPreferredProviderEnable == '1' && <div onClick={() => preferredProviderAction()} className={s.providerSectionCard}>
                    <div className={s.cardHeaderContainer}>
                        <div className={s.cardHeaderInnerFlexWrapper}>
                            <PreferredProviderIcon />
                            <h5 className={s.cardHeading}>{formatMessage(messages.preferredProviderLabel)}</h5>
                        </div>
                        <RightArrowIcon className={'iconRotate'} />
                    </div>
                    <div className={s.cardDescriptionContainer}>
                        <LightBulbIcon />
                        <p className={s.cardDescription}>{formatMessage(messages.preferredProviderSectionContent)}</p>
                    </div>
                </div>}
                {/* "Choose for me" (broadcast) card — now gated by the admin Booking-flow toggle
                    (randomProviderSelection), in parity with the mobile app. Disable the toggle in
                    admin to hide it; the besthand-api/web createBooking guard also blocks it server-side. */}
                {isRandomProviderEnable == '1' && <div onClick={() => handleRadomProviderAction()} className={s.providerSectionCard}>
                    <div className={s.cardHeaderContainer}>
                        <div className={s.cardHeaderInnerFlexWrapper}>
                            <RandomProviderIcon />
                            <h5 className={s.cardHeading}>{formatMessage(messages.radomProviderLabel)}</h5>
                        </div>
                        <RightArrowIcon className={'iconRotate'} />
                    </div>
                    <div className={s.cardDescriptionContainer}>
                        <LightBulbIcon />
                        <p className={s.cardDescription}>{formatMessage(messages.radomProviderSectionContent)}</p>
                    </div>
                </div>}
            </div>
            <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                <Button onClick={() => handleClick()} className={cx(bt.btnSecondary, bt.cursorPointer)} ><FormattedMessage {...messages.goBackText} /> </Button>
            </div>
        </>
    )
}

ProviderSelectionForm = reduxForm({
    form: 'ProviderSelectionForm',
})(ProviderSelectionForm);

export default withStyles(bt, s)(ProviderSelectionForm)